import React from 'react';

import type { AnswerButtonProps } from './AnswerButtonProps';
import { LikeButton } from './LikeButton';

export const DislikeAnswer = ({
	onClick,
	isSelected,
	spacing,
	testId,
}: AnswerButtonProps): React.JSX.Element => (
	<LikeButton
		onClick={onClick}
		isSelected={isSelected}
		spacing={spacing}
		testId={testId}
		isDislike
	/>
);
